$(function(){
  // ポスターがない場合
  if($('.haveOrNotSerchData').children().hasClass('haveSerchData')){
    $('.noSerchData').css("display","none");
  }else{
    $('.noSerchData-title').css({'cssText': 'display: none !important;'});
  }
  // キャラクターがない場合
  if($('.haveOrNotSerchData-character').children().hasClass('haveSerchData-character')){
    $('.noSerchData').css("display","none");
  }else{
    $('.noSerchData-title-character').css({'cssText': 'display: none !important;'});
  }
  // ボイスがない場合
  if($('.haveOrNotSerchData-charactervoice').children().hasClass('haveSerchData-charactervoice')){
    $('.noSerchData').css("display","none");
  }else{
    $('.noSerchData-title-charactervoice').css({'cssText': 'display: none !important;'});
  }
  // アルバムがない場合
  if($('.haveOrNotSerchData-album').children().hasClass('haveSerchData-album')){
    $('.noSerchData').css("display","none");
  }else{
    $('.noSerchData-title-album').css({'cssText': 'display: none !important;'});
  }
  // グッズがない場合
  if($('.haveOrNotSerchData-goods').children().hasClass('haveSerchData-goods')){
    $('.noSerchData').css("display","none");
  }else{
    $('.noSerchData-title-goods').css({'cssText': 'display: none !important;'});
  }
});
